import { takeLatest, put } from 'redux-saga/effects';

import { consts as applyGuarantorConsts } from '../requests/apply-guarantor-req';
import { determineNextStepAfterGuarantorInformation } from '../../appointmentForm/sagas/inspectAll-saga';
import { guarantorInformationActions } from '../actions';

export function* applyGuarantorInformation() {
  yield put(guarantorInformationActions.setIsSelfGuarantor(false));

  yield takeLatest(
    [applyGuarantorConsts.SUCCEED],
    determineNextStepAfterGuarantorInformation,
  );
}



// WEBPACK FOOTER //
// ./src/redux/guarantor-information/sagas/apply-guarantor.js